module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-title-pc@2x_840a8923be6b611eb7d1cffaa745c300.png";